import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` in the browser, `useEffect` on the server.
 *
 * `usePortalScope` must tag a portal before paint, but React warns that layout
 * effects do nothing during server rendering, and this package is written to
 * survive a non-browser environment (see `utils/localeStorage.ts`).
 */
export const useIsomorphicLayoutEffect =
  typeof window === 'undefined' ? useEffect : useLayoutEffect;
